<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
            <el-select v-model="listQuery.entity.docDown.goodsId" clearable  filterable placeholder="商品名称">
                <el-option
                        v-for="item in goods"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="文档名称"
                      v-model="listQuery.entity.docDown.name">
            </el-input>
        <!--    <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="文档链接"
                      v-model="listQuery.entity.docDown.linkRef">
            </el-input>-->
            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                       v-model="listQuery.entity.docDown.status"
                       placeholder="状态">
                <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
                </el-option>
            </el-select>
            <el-date-picker
                    @change='handleFilter'
                    value-format="yyyy-MM-dd HH:mm:ss"
                    class="filter-item input"
                    v-model="listQuery.entity.docDown.times"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="上传时间开始日期"
                    end-placeholder="上传时间结束日期">
            </el-date-picker>

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>
                <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                           v-if="canSave" icon="el-icon-edit">添加
                </el-button>
                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                           @click="handleDownload">导出
                </el-button>
            </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <yf-table-column align="center" label="ID">
                <template slot-scope="scope">
                    <span>{{scope.row.docDown.id}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="商品名">
                <template slot-scope="scope">
                    <span v-if="scope.row.docDown">{{scope.row.docDown.goodsName}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="文档名称">
                <template slot-scope="scope">
                    <span v-if="scope.row.docDown">{{scope.row.docDown.name}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="文档链接">
                <template slot-scope="scope">
                    <span v-if="scope.row.docDown">{{scope.row.docDown.linkRef}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="状态">
                <template slot-scope="scope">
                                                <span v-if="scope.row.docDown">

                         <el-tag :type="tagTypes[scope.row.docDown.status]" v-if="scope.row.docDown.status!=null">     {{statusOptions[scope.row.docDown.status]}}</el-tag>

                        </span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="上传时间" width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.docDown">{{parseTime(scope.row.docDown.time)}}</span>
                </template>
            </yf-table-column>

            <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </yf-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                <el-form-item label="商品名" prop="docDown.goodsId">
                    <el-select v-model="temp.docDown.goodsId" filterable placeholder="商品名">
                        <el-option
                                v-for="item in goods"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="文档名称" prop="docDown.name">
                    <el-input v-model="temp.docDown.name"></el-input>
                </el-form-item>
                <el-form-item label="文档链接" prop="docDown.linkRef">
                    <el-upload
                            class="upload-demo"
                            drag
                            action="https://upload.qiniup.com"
                            :file-list="docDownList"
                            :before-upload="handleUpload"
                            :on-preview="handlePreview"
                            :data="qData"
                            :on-success="(response, file, fileList)=>handleSuccess(docDownList,file)"
                            >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-form-item>
                <el-form-item v-if="!userId" label="状态" prop="docDown.status">
                    <el-select class="filter-item" v-model="temp.docDown.status" placeholder="状态">
                        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                                   :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上传时间" prop="docDown.time">
                    <el-date-picker v-model="temp.docDown.time" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="上传时间">
                    </el-date-picker>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, options, down, info, save, update, remove} from '@/api/doc_down'
    import waves from '@/directive/waves' // 水波纹指令
    import {getToken, domain} from '@/api/qiniu'
    import {downExcel} from '@/utils/down.js'
    import {parseTime} from '@/utils'
    import {listToStrs, strsToList} from '@/utils/imgUtil'


    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                time: null
                ,
                docDownList:[],
                goods:[],
                userId:null,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'docDown.id desc',
                    entity: {
                        docDown:
                            {
                                id: null, goodsId: null, name: null, linkRef: null, time: null, status: null
                            }
                    }
                },
                qData:
                    {
                        token: '',
                        key: ''
                    },
                statusOptions: [],
                tagTypes: ['info', '', 'warning', 'danger', 'warning'],
                temp: {

                    docDown:
                        {
                            id: null, goodsId: null, name: null, linkRef: null, time: null, status: null
                        }


                }
                ,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    update: '修改',
                    create: '新增'
                }
                ,
                rules:
                    {
                        'docDown.goodsId': [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'docDown.name': [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'docDown.linkRef': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'docDown.time': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'docDown.status': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'blur'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
            }
        },
        created() {
            this.getList()
            this.getOptions()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'doc:down:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'doc:down:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'doc:down:update')
            },
            canList() {
                return hasAuth(this.perms, 'doc:down:list')
            }
        },
        methods: {
            handlePreview(file) {
                if (!file.url) {
                    this.$message.error('下载失败')
                    return
                }
                const type = file.url.split('.')[4]
                // 判断文件类型
                if (type === 'doc' || type === 'docx' || type === 'xlsx' || type === 'xls' || type === 'ppt' || type === 'pptx') {
                    // 在当前浏览器直接下载
                    document.location.href = file.url
                } else {
                    // 图片在浏览器打开 新的页面展示
                    window.open(file.url, 'hello')
                }
            },
            handleSuccess(fileList, file) {
                if (fileList.length > 0){
                    fileList.splice(0,1)
                }
                fileList.push({name: file.response.key, url: domain + file.response.key})
            },
            parseTime(time) {
                if (!time) return ''
                return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
            },
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.goods = response.extra.goods
                    this.userId = response.extra.userId
                    this.total = response.data.total
                    this.listLoading = false
                })
            },
            initQiniu() {
                // 获取七牛配置
                getToken().then(res => {
                    this.qData.token = res.data
                }).catch(error => {
                    console.log(error)
                })
            },
            initImgUrl() {
                this.docDownList = strsToList(this.temp.docDown.linkRef, domain)
            },
            resetImgUrl() {
                this.docDownList = []
            },
            getOptions() {
                options().then(res => {
                    this.statusOptions = res.data.statusOptions
                })
            },
            handleUpload(file) {
                const type = file.name.split('.')[1]
                if (type==="txt"){
                    this.$message.error("不能上传txt格式的文件");
                    return
                }
                this.qData.key = new Date().valueOf() + file.name
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {
                this.resetTemp(row) // 更新数据
                // 存在图片
                this.initQiniu()
                this.initImgUrl()

            },
            afterFormShow(row) {

            },
            beforeFormCommit() {
                this.initImgName()// 图片转换
            },
            initImgName() {
                this.temp.docDown.linkRef = listToStrs(this.docDownList)
            },
            resetTemp(row) {

                this.temp = {
                    docDown: {}
                }
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            if (this.temp.docDown.linkRef ==null || this.temp.docDown.linkRef ==''){
                                this.$message.error("请上传文件");
                                return
                            }
                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.docDown.id]
                const ids = [this.list[this.index].docDown.id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
                this.beforeFormShow(scope.row)
                info(scope.row.docDown.id).then(res => {
                    this.temp = res.data
                    this.dialogStatus = 'update'
                    this.dialogFormVisible = true
                    this.$nextTick(() => {
                        this.$refs['dataForm'].clearValidate()
                    })
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            if (this.temp.docDown.linkRef ==null || this.temp.docDown.linkRef ==''){
                                this.$message.error("请上传文件");
                                return
                            }
                            update(this.temp).then(() => {
                                // this.list.splice(this.index, 1, this.temp)
                                this.getList()
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                this.dialogFormVisible = false
                this.resetImgUrl()
            },
            handleDownload() {
                this.downloadLoading = true
                down(this.listQuery).then(res => {
                    downExcel(res)
                    this.downloadLoading = false
                    this.$notify({
                        title: '成功',
                        message: '下载成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            // formatJson(filterVal, jsonData) {
            //     return jsonData.map(v => filterVal.map(j => {
            //         return v[j]
            //     }
            // ))
            // },
        }
    }
</script>
